import React, { useState, useEffect } from 'react';
import { useAuth } from '../context/AuthContext';
import { getOpenShift, closeShift, getDailyRevenue, getTips } from '../database/db';
import { format } from 'date-fns';
import { CheckCircle } from 'lucide-react';
const fmt = n => `AED ${Number(n||0).toFixed(2)}`;
export default function ShiftClose() {
  const { user, shift, refreshShift } = useAuth();
  const [cashHandover, setCashHandover] = useState('');
  const [tipsHandover, setTipsHandover] = useState('');
  const [note, setNote] = useState('');
  const [done, setDone] = useState(false);
  const [revenue, setRevenue] = useState(null);
  const [todayTips, setTodayTips] = useState(0);
  useEffect(() => {
    setRevenue(getDailyRevenue());
    const today = new Date().toISOString().split('T')[0];
    const tips = getTips().filter(t=>t.date===today&&t.staffId===user.id);
    setTodayTips(tips.reduce((s,t)=>s+(t.amount||0),0));
  }, [user.id]);
  const expectedCash = revenue?.totalCash||0;
  const handleClose = async() => {
    if (!cashHandover) return;
    if (!shift) return;
    await closeShift(shift.id, {cashHandover:parseFloat(cashHandover),tipsHandover:parseFloat(tipsHandover)||0,expectedCash,variance:parseFloat(cashHandover)-expectedCash,note,closedBy:user.id});
    refreshShift(); setDone(true);
  };
  if (done) return (
    <div className="fade-in">
      <div className="page-header"><div><div className="page-title">Shift Closed</div></div></div>
      <div className="page-body">
        <div className="card" style={{maxWidth:440,margin:'0 auto',textAlign:'center'}}>
          <div style={{fontSize:48,marginBottom:12}}>✅</div>
          <div style={{fontFamily:'var(--font-display)',fontSize:20,fontWeight:800,marginBottom:8}}>Shift Closed Successfully</div>
          <div style={{fontSize:13,color:'var(--text-muted)',marginBottom:20}}>{format(new Date(),'dd MMM yyyy · hh:mm a')}</div>
          <div className="alert alert-info" style={{fontSize:12}}>Admin will confirm your handover. Thank you.</div>
        </div>
      </div>
    </div>
  );
  return (
    <div className="fade-in">
      <div className="page-header"><div><div className="page-title">Close Shift</div><div className="page-subtitle">Submit cash handover</div></div></div>
      <div className="page-body">
        <div className="card" style={{maxWidth:440,margin:'0 auto'}}>
          {!shift&&<div className="alert alert-warning">No open shift found.</div>}
          <div className="card-title">Shift Summary</div>
          {shift&&<div style={{background:'var(--bg-input)',borderRadius:'var(--radius-sm)',padding:'14px 16px',marginBottom:16}}>
            <div className="flex-between" style={{marginBottom:6}}><span style={{fontSize:12,color:'var(--text-muted)'}}>Staff</span><span style={{fontWeight:600}}>{user.name}</span></div>
            <div className="flex-between" style={{marginBottom:6}}><span style={{fontSize:12,color:'var(--text-muted)'}}>Shift Started</span><span style={{fontSize:13}}>{format(new Date(shift.openedAt),'hh:mm a')}</span></div>
            <div className="flex-between" style={{marginBottom:6}}><span style={{fontSize:12,color:'var(--text-muted)'}}>Today Cash Revenue</span><span style={{fontFamily:'var(--font-mono)',color:'var(--success)',fontWeight:700}}>{fmt(expectedCash)}</span></div>
            <div className="flex-between"><span style={{fontSize:12,color:'var(--text-muted)'}}>Your Tips Today</span><span style={{fontFamily:'var(--font-mono)',color:'var(--warning)',fontWeight:700}}>{fmt(todayTips)}</span></div>
          </div>}
          <div className="form-group"><label className="form-label">Cash Handover Amount (AED) *</label><input className="form-input" type="number" placeholder="Count and enter cash" value={cashHandover} onChange={e=>setCashHandover(e.target.value)}/>{cashHandover&&revenue&&<div style={{marginTop:6,fontSize:12,padding:'6px 10px',background:'var(--bg-input)',borderRadius:'var(--radius-sm)',color:parseFloat(cashHandover)<expectedCash?'var(--danger)':parseFloat(cashHandover)>expectedCash?'var(--warning)':'var(--success)'}}>Variance: {parseFloat(cashHandover)>=expectedCash?'+':''}{fmt(parseFloat(cashHandover)-expectedCash)}</div>}</div>
          <div className="form-group"><label className="form-label">Tips to Handover (AED)</label><input className="form-input" type="number" placeholder="0.00" value={tipsHandover} onChange={e=>setTipsHandover(e.target.value)}/></div>
          <div className="form-group"><label className="form-label">Notes (optional)</label><input className="form-input" placeholder="Any issues for admin" value={note} onChange={e=>setNote(e.target.value)}/></div>
          <button className="btn btn-success btn-full btn-lg" onClick={handleClose} disabled={!shift||!cashHandover}><CheckCircle size={16}/> Close Shift & Submit Handover</button>
        </div>
      </div>
    </div>
  );
}
